import React, { useState, useEffect } from 'react';
import { MenuItem, SplitButton } from 'react-bootstrap';

export default function SelectColourButton({ title, groupingSequence, selectedColour, bStyle }) {
    const [buttonStyle, setButtonStyle] = useState(bStyle === '' ? 'default' : bStyle);

    useEffect(() => {
        if (bStyle !== '' && bStyle !== buttonStyle) {
            setButtonStyle(bStyle);
        }
    }, [bStyle]);

    function buttonClicked(newStyle) {
        setButtonStyle(newStyle);
        selectedColour(newStyle);
    }

    return (
        <div>
            <SplitButton
                bsStyle={buttonStyle}
                title={title}
                key={22}
                id={22 + groupingSequence}
                onSelect={buttonClicked}
            >
                <MenuItem eventKey="default">White</MenuItem>
                <MenuItem eventKey="primary">Blue</MenuItem>
                <MenuItem eventKey="success">Green</MenuItem>
                <MenuItem eventKey="info">Light Blue</MenuItem>
                <MenuItem eventKey="warning">Orange</MenuItem>
                <MenuItem eventKey="danger">Red</MenuItem>
            </SplitButton>
        </div>
    );
}
